export default __webpack_public_path__ + "static/media/icn_dummy_image.c7e76abd.svg";